import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_SIL_DEVICE,
    StoreType,
    SilDeviceProps,
    LoadSilDeviceById,
    setSilDeviceEdit,
    setSilDeviceReloadEdit,
    initSilDevice,
    initSilProjectDevice,
} from "client/store"

import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const DeviceEdit = ({
    deviceId = null,
}: SilDeviceProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)

    const device = useSelector((state: StoreType) => state.silDevice.deviceEdit)
    const reloadEdit = useSelector((state: StoreType) => state.silDevice.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setSilDeviceReloadEdit(false))
        setTimeout(() => {
            dispatch(setSilDeviceReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (deviceId === 0) {
            dispatch(setSilDeviceEdit(project.id ? initSilProjectDevice : initSilDevice))
            reload()
        } else {
            setLoadState(PENDING)
            LoadSilDeviceById(deviceId, userData.accountId, project.id).then((res) => {
                dispatch(setSilDeviceEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    const addAccess = !project.id
        ? hasAccess(PRM_SIL_DEVICE, ADD)
        : hasProjectAccess(PRM_SIL_DEVICE, ADD)

    const editAccess = !project.id
        ? hasAccess(PRM_SIL_DEVICE, EDIT)
        : hasProjectAccess(PRM_SIL_DEVICE, EDIT)

    if (deviceId === 0 && !addAccess) return <AccessDenied />
    if (deviceId !== 0 && !editAccess) return <AccessDenied />
    if (!device) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>{device.id ? `${lang.editDevice} # ${device.id}` : lang.addDevice}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form device={device} />
                }
                {
                    reloadEdit
                    && <Form device={device} />
                }
            </PageContent>
        </Container>
    )
}
export default DeviceEdit
